import {
    XLayout,
    XLayoutHeader,
    XLayoutSide,
    XLayoutContent,
    XLayoutFooter,
} from './xlayout';
import {
    XSplit,
    XSplitPane,
} from './xsplit';

const install = function (app) {
    app.component(XLayout.name, XLayout);
    app.component(XLayoutHeader.name, XLayoutHeader);
    app.component(XLayoutSide.name, XLayoutSide);
    app.component(XLayoutContent.name, XLayoutContent);
    app.component(XLayoutFooter.name, XLayoutFooter);
    app.component(XSplit.name, XSplit);
    app.component(XSplitPane.name, XSplitPane);
};

export {
    XLayout,
    XLayoutHeader,
    XLayoutSide,
    XLayoutContent,
    XLayoutFooter,
    XSplit,
    XSplitPane,
    install,
};
